import React from "react";
import { Route, Redirect } from "react-router-dom";

const PrivateRoute = ({ component: Component, ...rest }) => {
  let language = undefined;
  return (
    <Route
      {...rest}
      render={(props) =>
        language ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/en",
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
